<template>
  <div class="container fluid">
    <div class="mb-2">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm6>
          <v-btn
            depressed
            :outline="channelFilter != 'all'"
            :color="channelFilter == 'all' ? 'primary' : 'grey'"
            @click="channelFilter = 'all'"
            class="ma-0 mr-1 mb-1"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="channelFilter != 'facebook'"
            :color="channelFilter == 'facebook' ? 'primary' : 'grey'"
            @click="channelFilter = 'facebook'"
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="channelFilter != 'line'"
            :color="channelFilter == 'line' ? 'primary' : 'grey'"
            @click="channelFilter = 'line'"
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-line mr-1" />
            {{ $t('Line') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-xs-right">
          <div class="text-xs-right">
            <exportxlsx :promisedValue="getXlsxData"></exportxlsx>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="mb-2">
      <date-filter
        @changeDate="onChangeDate"
        :defaultFilter="'last_7_days'"
        v-model="selectedDate"
      ></date-filter>
    </div>
    <div class="mb-2">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm12 class="text-xs-right">
          <v-btn
            depressed
            outline
            color="primary"
            @click="showsearch = true"
            class="ma-0 mr-1 mb-1"
          >
            <v-icon>search</v-icon>&nbsp;{{ $t('Advanced Search') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm9>
          <div>
            <v-pagination
              :total-visible="6"
              v-model="pageNumber"
              @input="changePage"
              :length="pagelength"
            ></v-pagination>
          </div>
        </v-flex>

        <v-flex xs12 sm3 class="text-xs-right primary--text pt-4" style="font-weight: 700">
          Total : {{ total }}
        </v-flex>
      </v-layout>
    </div>

    <div>
      <v-data-table
        :headers="headers"
        :items="dataGiftReport"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1 mt-4"
      >
        <!-- hide-actions -->
        <template v-slot:items="props">
          <tr>
            <td>{{ getDateFormatted(props.item.timestamp) }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.member_type }}</td>
            <td>{{ props.item.product_name }}</td>
            <td>{{ props.item.redeem_for }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <div class="mt-2">
      <v-pagination
        :total-visible="6"
        v-model="pageNumber"
        @input="changePage"
        :length="pagelength"
      ></v-pagination>
    </div>

    <!-- Modal Search -->
    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn @click="showsearch = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Name') }}</label>
                <input v-model="filter.name" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Member Level') }}</label>
                <Multiselect
                  @input="getGiftSubcategory"
                  placeholder="Choose Member Level"
                  v-model="filter.member_type"
                  :options="categorylist"
                  label="name"
                ></Multiselect>
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Redeem For') }}</label>
                <!-- :disabled="!filter.member_type" -->
                <Multiselect
                  placeholder="Choose Redeem For"
                  v-model="filter.redeem_for"
                  :options="subcategorylist"
                  label="name"
                ></Multiselect>
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
            <v-btn @click="onsearch" color="primary">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    ScaleLoader,
    exportxlsx,
    DateFilter,
    DatePickerWithoutButton,
    Multiselect
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: 'Date Of Redeem', value: 'timestamp', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Level', value: 'member_type', sortable: false },
        { text: 'Gift', value: 'product_name', sortable: false },
        { text: 'Redeem For', value: 'redeem_for', sortable: false }
      ],
      channelFilter: 'all',
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      filter: {
        name: '',
        member_type: '',
        redeem_for: ''
      },
      loading: false,
      dataGiftReport: [],
      showsearch: false,
      memberTypeData: [
        { text: 'New Member', value: 'new' },
        { text: 'Silver Member', value: 'silver' },
        { text: 'Gold Member', value: 'gold' }
      ],
      categorylist: [],
      subcategorylist: []
    }
  },
  mounted() {
    this.getGiftReport()
    this.getGiftCategory()
    // this.getGiftSubcategory();
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    filterMemberType() {
      return this.filter.member_type
    }
  },
  methods: {
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.limit = this.total
        var data = await this.getGiftReport()

        resolve(
          data.map((el) => {
            return {
              Date_Of_Redeem: el.timestamp ? moment(el.timestamp).format('DD/MM/YYYY') : '',
              Name: el.name,
              Level: el.member_type,
              Gift: el.product_name,
              Redeem_For: el.redeem_for
            }
          })
        )

        this.limit = 10
      })
    },
    getGiftReport() {
      return new Promise((resolve) => {
        var vm = this
        var data = {
          pageid: vm.selectedBot.pageid, // required
          limit: vm.limit, // required
          offset: vm.offset, // required
          name: vm.filter.name,
          member_type: vm.filter.member_type.name,
          redeem_for: vm.filter.redeem_for.name,
          start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
          end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD')
        }

        vm.loading = true
        api.getLamyGiftReport(data, (err, response) => {
          if (response.responsecode == 200) {
            vm.dataGiftReport = response.data
            vm.total = response.total
            vm.loading = false
            resolve(response.data)
          } else {
            console.log(err)
            return
          }
        })
      })
    },
    getGiftCategory() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        limit: vm.limit,
        offset: vm.offset
      }

      api.getLamyGiftCategory(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.categorylist = response.data
      })
    },
    getGiftSubcategory() {
      var vm = this

      if (vm.filter.member_type == '') {
        vm.filter.redeem_for = ''
        vm.subcategorylist = []
      } else {
        var data = {
          pageid: vm.selectedBot.pageid,
          category_id: vm.filter.member_type.id,
          limit: vm.limit,
          offset: vm.offset
        }

        api.getLamyGiftSubCategory(data, function (error, response) {
          if (error) {
            console.error(error)
            return
          }
          vm.subcategorylist = response.data
        })
      }
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getGiftReport()
      }
    },
    onsearch() {
      this.getGiftReport()
      this.showsearch = false
    },
    clearsearch() {
      this.filter = {
        name: '',
        member_type: '',
        redeem_for: ''
      }
      this.subcategorylist = []
      this.onsearch()
    },
    onChangeDate() {
      this.getGiftReport()
    }
  }, // End Methods
  watch: {
    selectedDate: {
      handler: function (newValue) {
        this.getGiftReport()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/GiftReport.vue